<div class="manage-user-profile-container">
  <!-- Profile header -->
  <div class="profile-acfs" [class.centered]="!profileCompleted()">
  </div>

  @if (showHomeView()) {
    <app-user-profile></app-user-profile>
    <div class="menu-list">
      @if (profileCompleted()) {
        <a class="menu-card" routerLink="./business">
          <div class="menu-card-icon"><i class="bi bi-briefcase"></i></div>
          <div class="menu-card-info">
            <h3 class="menu-card-title">ข้อมูลธุรกิจ</h3>
            <p class="menu-card-desc">รายละเอียดธุรกิจการเกษตรของคุณ</p>
          </div>
          <div class="menu-card-arrow"><i class="bi bi-chevron-right"></i></div>
        </a>

        <!-- Any business owner may delegate and anyone may be delegated to (work item 173): no role gate. -->
        <a class="menu-card" routerLink="/profile/role-assign">
          <div class="menu-card-icon"><i class="bi bi-shield-check"></i></div>
          <div class="menu-card-info">
            <h3 class="menu-card-title">มอบสิทธิ์ใช้งาน</h3>
            <p class="menu-card-desc">จัดการสิทธิ์การเข้าถึงระบบ</p>
          </div>
          <div class="menu-card-arrow"><i class="bi bi-chevron-right"></i></div>
        </a>

        <a class="menu-card" routerLink="/profile/role-invitations">
          <div class="menu-card-icon"><i class="bi bi-envelope-check"></i></div>
          <div class="menu-card-info">
            <h3 class="menu-card-title d-flex align-items-center">
              <span>ตอบรับคำเชิญ</span>
              @if (pendingInvitationCount() > 0) {
                <span class="badge rounded-pill bg-danger ms-2">{{ pendingInvitationCount() }}</span>
              }
            </h3>
            <p class="menu-card-desc">ตอบรับหรือปฏิเสธคำเชิญให้ดำเนินการแทน</p>
          </div>
          <div class="menu-card-arrow"><i class="bi bi-chevron-right"></i></div>
        </a>
      }

      <!-- Logout -->
      <button class="menu-card logout" (click)="logout()">
        <div class="menu-card-icon text-danger"><i class="bi bi-box-arrow-right"></i></div>
        <div class="menu-card-info">
          <h3 class="menu-card-title text-danger">ออกจากระบบ</h3>
          <p class="menu-card-desc">ออกจากระบบและกลับไปยังหน้าเข้าสู่ระบบ</p>
        </div>
        <div class="menu-card-arrow text-danger"><i class="bi bi-chevron-right"></i></div>
      </button>
    </div>
  } @else {
    <router-outlet/>
  }
</div>
